import React, { useEffect, useState } from 'react';
import { DataTable } from '@/v2/components/DataTable/tasks/components/data-table';
import { DataTableColumnHeader } from '@/v2/components/DataTable/tasks/components/data-table-column-header';
import useFetch from 'use-http';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  useUserDispatch,
  useUserState,
} from '@/components/context/UserContext';
import { getQueryString } from '@/components/constants/visitsQueryStringBuilder';
import { InfoButton } from '@/components/ui/shared/InfoButton';

export default function ReferralsTable() {
  const { t } = useTranslation();
  const history = useHistory();
  const sessionDispatch = useUserDispatch();
  const userState = useUserState();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [dateRange, setDateRange] = useState(userState.dateFilter);

  const { get: getReferrals, response: referralsResponse } = useFetch(
    '/UserAccount/ReferralsList',
  );
  const { get: getReferral } = useFetch('/UserAccount/Referral');

  const fetchData = async (date = dateRange, searchTerm = search) => {
    setIsLoading(true);

    sessionDispatch({
      type: 'UPDATE',
      data: { dateFilter: date },
    });

    const query = getQueryString(
      date,
      searchTerm,
      undefined,
      undefined,
      userState.espbiEsi,
    );

    const result = await getReferrals(query);

    if (referralsResponse.ok) {
      const sorted = _.orderBy(result, ['occurrenceDateTime'], ['desc']);
      setData(sorted);
    }

    setIsLoading(false);
  };

  const handleSelection = async (id) => {
    setIsLoading(true);

    const query = userState.espbiEsi
      ? `?id=${id}&espbiEsi=${userState.espbiEsi}`
      : `?id=${id}`;

    const res = await getReferral(query);

    history.push('/userAccount/referrals/details', { data: res });
  };

  useEffect(() => {
    fetchData();
  }, [dateRange, userState?.espbiEsi]);

  return (
    <DataTable
      title="Siuntimai"
      loading={isLoading}
      columns={columns({ handleSelection })}
      data={data}
      filterableColumns={['specialty', 'occurrenceDateTime']}
      onRowClick={(row) => handleSelection(row.id)}
    />
  );
}

const capitalizeFirstLetter = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const formatDateWithoutConversion = (date) => {
  if (!date) {
    return '-';
  }

  const value = String(date);
  const datePart = value.substring(0, 10);
  const timePart = value.substring(11, 16);

  if (!datePart) {
    return '-';
  }

  if (!timePart || timePart === '00:00') {
    return datePart;
  }

  return `${datePart} ${timePart}`;
};

const columns = ({ handleSelection }) => [
  {
    accessorKey: 'specialty',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="SPECIALISTAS" />
    ),
    cell: ({ row }) => (
      <span className="font-medium max-w-[400px] truncate ">
        {capitalizeFirstLetter(row.original.specialty)}
      </span>
    ),
  },
  {
    accessorKey: 'occurrenceDateTime',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="DATA" />
    ),
    cell: ({ row }) => (
      <span className="text-muted-foreground">
        {formatDateWithoutConversion(row.original.occurrenceDateTime)}
      </span>
    ),
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <InfoButton
          onClick={(e) => {
            e.stopPropagation();
            handleSelection(row.original.id);
          }}
        >
          Informacija
        </InfoButton>
      </div>
    ),
  },
];
